import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface DeleteModuleFromUserPlanInput {
	readonly userId: string;
	readonly moduleId: string;
}

export interface DeleteModuleFromUserPlanParams {
	input: DeleteModuleFromUserPlanInput;
}

@Injectable({ providedIn: 'root' })
export class DeleteModuleFromUserPlanApiMutation extends ApiMutation<
	void,
	DeleteModuleFromUserPlanParams
> {
	client = 'content';
	document = gql`
		mutation DeleteModuleFromUserPlan($input: DeleteModuleFromUserPlanInput!) {
			deleteModuleFromUserPlan(input: $input)
		}
	`;
	method = 'deleteModuleFromUserPlan';
}
